import React, { useState, useEffect, } from "react";
import { Redirect, 
	// useHistory
 } from 'react-router-dom';

// reactstrap components
import {
	Button,
	Card,
	CardTitle,
	CardHeader,
	Form,
	Input,
	Container,
	Row,
	Col,
	Modal
} from "reactstrap";

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import fb, { currentUser } from 'fb'

function Login() {

	document.documentElement.classList.remove("nav-open");
	useEffect(() => {
		document.body.classList.add("login-page");
		document.body.classList.add("full-screen");
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		return function cleanup() {
			document.body.classList.remove("login-page");
			document.body.classList.remove("full-screen");
		};
	});

	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [errMsg, setErrMsg] = useState("")

	const [failModal, setFailModal] = useState(false);

	// const history = useHistory()

	const login = async () => {
		try {
			await fb.auth().signInWithEmailAndPassword(email, password)
			// redirect to home page
			// history.push("/")
			.catch(error => {

				if (error.code === "auth/invalid-email") {
					setErrMsg("Oops... Invalid Email!!")
				}
				else if (error.code === "auth/user-not-found") {
					setErrMsg("Oops... There is no such user")
				}
				else if (error.code === "auth/wrong-password") {
					setErrMsg("Oops... Wrong Password!!")
				}
	
				reset()

				setFailModal(true)
				
			})
		} catch (error) {
			
		}
	}

	const reset = () => {
		setEmail("")
		setPassword("")
	}

	return (
		<>
			{
				!currentUser() ?
					<>
						<ColorNavbar />
						<div className="wrapper">
							<div
								className="page-header"
								style={{
									backgroundColor: "#000000"
								}}
							>
								<div className="" />
								<Container>
									<Row>
										<Col className="ml-auto mr-auto" lg="4" md="6" sm="6">
											<Card className="card-register" style={{backgroundColor:"#ffffff"}}>
												<CardTitle tag="h3" style={{color:"#000000"}}>Welcome</CardTitle>
												<Form className="">
													<label>Email</label>
													<Input
														className=""
														placeholder="Email"
														type="email"
														onChange={event => setEmail(event.target.value)}
														id="email"
													/>
													<label>Password</label>
													<Input
														className=""
														placeholder="Password"
														type="password"
														onChange={event => setPassword(event.target.value)}
														id="password"
													/>
													<Button block className="btn-round" color="" onClick={login}>
														Login
                    								</Button>
												</Form>
											</Card>
										</Col>
									</Row>
									<div className="demo-footer text-center">
										<h6>
											© {new Date().getFullYear()}
										</h6>
									</div>
								</Container>
							</div>
						</div>
					</>
					:
					<Redirect to="/" />
			}
			<Modal
				size="xs"
				isOpen={failModal}
				toggle={() => setFailModal(false)}
				style={{ maxWidth: "400px" }}
			>
				<Card>
					<CardHeader>
						<div className="modal-body text-center">
							<h5>
								{errMsg}
                            </h5>
						</div>
					</CardHeader>
					<Button
						className="btn-success"
						color="danger"
						type="button"
						onClick={() => setFailModal(false)}
					>
						Ok
                    </Button>
				</Card>
			</Modal>
		</>
	);
}

export default Login;
